/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const NoOptionsMessage = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.NoOptionsMessage;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

NoOptionsMessage.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      NoOptionsMessage: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

NoOptionsMessage.defaultProps = {
  selectProps: {
    custom: {
      NoOptionsMessage: null,
    },
  },
  children: null,
};

export default NoOptionsMessage;
